<template>
    <div>
        <el-page-header @back="goBack" content=""></el-page-header>
        <el-card shadow="never" class="aui-card--fill box-card">
            <div class="mod-demo__news">
                <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                    <el-form-item>
                        <el-input v-model="dataForm.title" placeholder="请输入残协名称或专职委员" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="getDataList()">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table v-if="dataForm.taskType == '3'" v-loading="dataListLoading" :data="dataList" border
                    @selection-change="dataListSelectionChangeHandle" @sort-change="dataListSortChangeHandle"
                    style="width: 100%">
                    <el-table-column prop="photoUrl" label="照片" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-image v-if="scope.row.photoUrl"  style="width: 32px; height: 32px" :src="scope.row.photoUrl?scope.row.photoUrl:''" :preview-src-list="[scope.row.photoUrl]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="updater" label="村残协" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="creator" label="专职委员" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="handicappedMobile" label="联系电话" header-align="center"
                        align="center"></el-table-column>
                    <el-table-column prop="taskStatus" label="是否完成" header-align="center" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.taskStatus == '1'">未完成</span>
                            <span v-if="scope.row.taskStatus == '2'">已完成</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="lookDetail(scope.row.id,scope.row.taskType)">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table v-if="dataForm.taskType != '3'" v-loading="dataListLoading" :data="dataList" border
                    @selection-change="dataListSelectionChangeHandle" @sort-change="dataListSortChangeHandle"
                    style="width: 100%">
                    <el-table-column prop="photoUrl" label="照片" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-image v-if="scope.row.photoUrl" style="width: 32px; height: 32px" :src="scope.row.photoUrl?scope.row.photoUrl:''" :preview-src-list="[scope.row.photoUrl]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="handicappedXm" label="姓名" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="sex" label="性别" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="educationBackground" label="学历" header-align="center"
                        align="center"></el-table-column>
                    <el-table-column prop="cjInfo" label="残疾等级" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="taskStatus" label="是否完成" header-align="center" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.taskStatus == '1'">未完成</span>
                            <span v-if="scope.row.taskStatus == '2'">已完成</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="lookDetail(scope.row.id,scope.row.taskType)">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" :total="total"
                    layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
                </el-pagination>
                <!-- 查看详情-->
                <condition-detail v-if="OpenViewAssociation" ref="ViewAssociation"></condition-detail>
            </div>
        </el-card>
    </div>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import conditionDetail from './conditionDetail';
export default {
    mixins: [mixinViewModule],
    components: {
        conditionDetail,
    },
    data() {
        return {
            mixinViewModuleOptions: {
                getDataListURL: "/task/resultList",
                getDataListIsPage: true,
                deleteURL: "/demo/news",
                deleteIsBatch: true,
                createdIsNeed: false,
            },
            daterange: null,
            dataForm: {
                taskId: '',
                title: "",
                startDate: "",
                endDate: "",
                area: JSON.parse(localStorage.getItem('org')).area || ''
            },
            OpenViewAssociation: false,
        };
    },
    watch: {
        daterange(val) {
            if (val == null) {
                this.dataForm.startDate = null;
                this.dataForm.endDate = null;
            } else {
                this.dataForm.startDate = val[0];
                this.dataForm.endDate = val[1];
            }
        },
    },
    created() {
        this.dataForm.taskId = this.$route.query.id
        this.dataForm.taskType = this.$route.query.taskType
        this.query()
        if (!this.$route.query) return;

    },
    methods: {
        goBack() {
            this.$router.back(-1);
        },
        lookDetail(id, taskType) {
            //查看详情
            this.OpenViewAssociation = true;
            this.$nextTick(() => {
                this.$refs.ViewAssociation.init(id,taskType);
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.box-card {
    margin-top: 30px;
}
</style>

